const { map, reduce, isObject } = require('lodash');

const filterType = {

    /**
     * Encodes a filter object into a URL friendly string to be used in query params.
     *
     * @param {object} filter - A filter object for Olympic Search.
     * @returns {string}
     */
    encode(filter) {
        if (!filter) {
            return '';
        }

        return map(filter.filters,
            ({ Key, Items }) => `${Key}(${Items.map(i => i.Term).join(',')})`,
        ).join(';');
    },

    /**
     * Decodes a filter param from the URL into a filter object for Olympic Search.
     *
     * @param {string} filterParam - Filter parameter of the format 'Key1(Term,Term);Key2(Term,Term)'
     * @returns {object}
     */
    decode(filterParam) {
        if (!filterParam) {
            return { filters: [] };
        }

        return {
            filters: reduce(filterParam.split(';'), (filters, filterString) => {
                // matches eg 'Category(1_03F7B3C,1_03F7B3C)' -> ['Category(1_03F7B3C,1_03F7B3C)', 'Category', '1_03F7B3C,1_03F7B3C']
                const parts = filterString.match(/([a-z]+)\(([a-z0-9_\-,]+)\)/i);

                if (parts && parts.length === 3) {
                    filters.push({
                        Key: parts[1],
                        Items: parts[2].split(',').map(i => ({ Term: i })),
                    });
                }
                return filters;
            }, []),
        };
    },

    is(item) {
        return isObject(item) && 'filters' in item;
    },
};

module.exports = { filterType };



// WEBPACK FOOTER //
// ./src/configuration/filterparamtype.js